'use strict';
import angular from 'angular';

// import VisitorsService from './modules/visitors/visitors.service';
export default class AppController {
	/*@ngInject*/
	constructor($scope, $window, $rootScope,AppService,$timeout){
		// add 'ie' classes to html
		var isIE = !!navigator.userAgent.match(/MSIE/i);
		if(isIE){ angular.element($window.document.body).addClass('ie');}
		if(window.isSmartDevice($window)){ angular.element($window.document.body).addClass('smart')}

		/*$scope.data = {
			availableOptions: [
				{key: '0', name: 'all'},
				{key: '1', name: 'Firewall'},
				{key: '2', name: 'app2'},
				{key: '3', name: 'app3'}
			],
			selectedOption: {key: '0', name: 'all'} //This sets the default value of the select in the ui
		};*/
		$scope.data = {
			availableOptions: AppService.getAppKeys(),
			selectedOption: {key: '0', name: 'all'} //This sets the default value of the select in the ui
		};
		// config
		$scope.app = {
			name:'Cleaning Stuff',
			version:'1.0.0',
			// for chart colors
			color:{
				primary:'#7266ba',
				info:'#23b7e5',
				success:'#27c24c',
				warning:'#fad733',
				danger:'#f05050',
				light:'#e8eff0',
				dark:'#3a3f51',
				black:'#1c2b36'
			},
			settings:{
				themeID:1,
				navbarHeaderColor:'bg-black',
				navbarCollapseColor:'bg-white-only',
				asideColor:'bg-black',
				headerFixed:true,
				asideFixed:false,
				asideFolded:false,
				asideDock:false,
				container:false
			}
		}
		// $timeout(function(){
		$scope.app.isLoaded=true;
		// },5000);
		$scope.update = function() {
			$rootScope.$broadcast('changeAppKey',$scope.data.selectedOption);
		}

		// save settings to local storage
		// if(angular.isDefined($localStorage.settings)){
		// 	$scope.app.settings = $localStorage.settings;
		// } else{
		// 	$localStorage.settings = $scope.app.settings;
		// }
		$scope.$watch('app.settings', function(){
			if($scope.app.settings.asideDock && $scope.app.settings.asideFixed){
				// aside dock and fixed must set the header fixed.
				$scope.app.settings.headerFixed = true;
			}
			// for box layout, add background image
			$scope.app.settings.container ? angular.element('html').addClass('bg') : angular.element('html').removeClass('bg');
			// save to local storage
			//$localStorage.settings = $scope.app.settings;
		}, true);
	}
}


// WEBPACK FOOTER //
// ./src/app/application.controller.js